import * as React from 'react';
import { getAppServices } from 'providers/app-services';
import { FeatureFlag } from './constants';
import { FeatureFlagsContext } from './FeatureFlagsContext';

const getFeatureFlags = (
  featureFlagService: Bluebeam.Services.IFeatureFlagService
) => {
  return Object.values(FeatureFlag).reduce((accumulator, flag) => {
    accumulator[flag] = featureFlagService.hasFeature(flag);
    return accumulator;
  }, {} as Record<Bluebeam.FeatureFlags.Models.FeatureFlag, boolean>);
};

const FeatureFlagsProvider: React.FC = ({ children }) => {
  const { featureFlagService } = getAppServices();
  const [featureFlags, setFeatureFlags] = React.useState(() =>
    getFeatureFlags(featureFlagService)
  );

  React.useEffect(() => {
    const subscriptionId = featureFlagService.subscribe(() => {
      setFeatureFlags(getFeatureFlags(featureFlagService));
    });

    return () => {
      featureFlagService.unsubscribe(subscriptionId);
    };
  }, [featureFlagService]);

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsProvider;
